<template>



    <div class="main-nav">
        <div class="nav-container">
            <div class="header-bar">
                <svg class="logo" viewBox="0 0 218.18 22" id="paychexbeta_logo" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M20.77 7.26c0-4.65-2.46-6.76-6.24-6.76H4.3L0 21.5h6.27l1.3-6.34h4.28c5.42.01 8.92-3.64 8.92-7.9zM11 10.16H8.61l.89-4.29h2.16c1.33 0 2.75.27 2.75 1.89 0 1.43-.83 2.4-3.41 2.4zM26.79.51l-11.92 21h6.47l1.59-3h6.73l.35 3h6.23L33 .51zM25.23 14l3.21-6.29h.06l.69 6.29h-4zM48.93.51l-5 7.82-2-7.82h-6.4L40 13.8l-1.56 7.7h6.35l1.56-7.76 10-13.23zm17 13c-.4 1.85-1.53 3.23-3.52 3.23-2.92 0-3.33-2.7-3.33-4.44 0-3 1.27-7.07 4.8-7.07 2 0 2.89 1.12 2.83 3.08h6C72.55 2 68.45 0 63.85 0c-7 0-11.19 5.66-11.19 12.44 0 5.56 2.89 9.56 8.87 9.56 8.58 0 10.2-6.34 10.58-8.48h-6.18zm22.63-13L87 7.86h-5.8L82.7.5h-6.32l-4.3 21h6.35l1.7-8.27h5.8l-1.7 8.27h6.35l4.35-21h-6.37zm38.24 0L122.68 6l-2-5.47H97.1l-4.31 21h23.76l4.76-5.87 2.28 5.87h7.13l-5-11.14L134.3.53h-7.54zm-16.31 19l.7-3.42h-10.94l.55-2.66h9.94l1-5h-9.91l.55-2.61h10.69L114 1l4.48 9.35zm38.14-10.27l1-4.85h7.78l3.37-3.88h-14.92l-4.44 21H146l1.85-8.67h6.26l3.1-3.59h-8.58zm13.92 8.38L166.14.5h-4.64l-4.41 21h12.26l3.32-3.88zm15.47 0l1.09-5.15 6.35-.07 3-3.52h-8.63l.94-4.5h7.8L191.82.5H177l-4.41 21h12.7l3.36-3.88h-10.63zM211.29.51h-5.47l-5.38 6.94-3-6.94h-5l4.91 9.94-9.56 11.05h5.59l6-7.5 3.29 7.5h5.09l-5.2-10.85zM215.18 0a3 3 0 0 0-3 3.07 3 3 0 0 0 3 3.07 3 3 0 0 0 3-3.07 3 3 0 0 0-3-3.07zm0 5.65a2.52 2.52 0 0 1-2.53-2.59 2.53 2.53 0 1 1 5.05 0 2.45 2.45 0 0 1-2.52 2.59zm1.38-3.43c0-.6-.36-1-1.14-1h-1.32v3.59h.42V3.25h.72l1 1.56h.48l-1-1.56c.48-.12.84-.36.84-1.02zm-1.44.6h-.54v-1.2h.78c.42 0 .84.12.84.6s-.54.61-1.08.61z" fill="#fff"></path></svg>
            </div>

            <div class="app-links">
                <div class="app-group-header">
                    <span>MAIN</span>
                </div>
                <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="dashboard")'  @click="onNavLink('/admin/dashboard')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="dashboard" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M15 7a8 8 0 1 1-8 8 8 8 0 0 1 8-8m0-1a9 9 0 1 0 9 9 9 9 0 0 0-9-9z" ></path><circle cx="14.92" cy="9" r="1" ></circle><circle cx="21" cy="15" r="1" ></circle><circle cx="10.76" cy="10.76" r="1" ></circle><circle cx="19.24" cy="10.76" r="1" ></circle><circle cx="9" cy="15" r="1" ></circle><path d="M15 11s-2 6.9-2 8a2 2 0 0 0 4 0c0-1.1-2-8-2-8zm-.08 9a1 1 0 1 1 1-1 1 1 0 0 1-1 1z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Dashboard</span>
                    </div>
                </div>
              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="reports")' @click="onNavLink('/admin/reports')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="report-center" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M13.88 22.83H6.94V7.16h10.59v2.21h2.35v2.79a6.59 6.59 0 0 1 1.09.31V8.16l-1.72-1.64-.54-.52H6.53a.69.69 0 0 0-.7.67v16.65a.69.69 0 0 0 .7.67h8.71a6.52 6.52 0 0 1-1.36-1.16" ></path><path d="M18.47 17.91l2-4.58A5.47 5.47 0 0 0 15 14.46zM19.12 18.17h5.06a5.49 5.49 0 0 0-3.06-4.57zM18.93 18.87V24a5.48 5.48 0 0 0 5.24-5.13h-5.24zM18.23 18.67L14.52 15a5.48 5.48 0 0 0 3.7 9v-5.33zM15.44 12.93H8.6v1.21h5.34a6.45 6.45 0 0 1 1.5-1.21M8.6 9.7h4.04v1.21H8.6zM8.6 16.16v1.21h3.73a6.29 6.29 0 0 1 .34-1.21H8.6zM8.6 19.4v1.21h4a6.41 6.41 0 0 1-.28-1.21H8.6z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Analytics & Reports</span>
                    </div>
                </div>
              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="payroll")' @click="onNavLink('/admin/payroll-center')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="payroll" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16.48 13.13c-.66-.24-1.3-.52-1.22-1a1.19 1.19 0 0 1 1.32-.72 2.77 2.77 0 0 1 1.87.77l.26.24 2-3.07-.21-.17a6.09 6.09 0 0 0-2.81-1L18 6h-2.2l-.33 2.13a5.13 5.13 0 0 0-4.2 4.33c-.37 2.34 1.07 3.23 2.36 3.75l.81.29c1.07.36 1.52.57 1.45 1a1.49 1.49 0 0 1-1.52 1 4 4 0 0 1-2.67-1.36l-.26-.28-2.18 3.2.16.18a5.18 5.18 0 0 0 2 1.23 6 6 0 0 0 1.92.44L13 24h2.2l.35-2.24c2.54-.67 4-2.12 4.33-4.46.44-2.81-1.75-3.59-3.41-4.18" ></path><path d="M16.48 13.13c-.66-.24-1.3-.52-1.22-1a1.19 1.19 0 0 1 1.32-.72 2.77 2.77 0 0 1 1.87.77l.26.24 2-3.07-.21-.17a6.09 6.09 0 0 0-2.81-1L18 6h-2.2l-.33 2.13a5.13 5.13 0 0 0-4.2 4.33c-.37 2.34 1.07 3.23 2.36 3.75l.81.29c1.07.36 1.52.57 1.45 1a1.49 1.49 0 0 1-1.52 1 4 4 0 0 1-2.67-1.36l-.26-.28-2.18 3.2.16.18a5.18 5.18 0 0 0 2 1.23 6 6 0 0 0 1.92.44L13 24h2.2l.35-2.24c2.54-.67 4-2.12 4.33-4.46.44-2.81-1.75-3.59-3.41-4.18" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Payroll Center</span>
                    </div>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="hr")' @click="onNavLink('/admin/hr')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="human-resources_cache8" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path   d="M11.89 13.96H8.77V10H6.23v10.22h2.54v-4.18h3.12v4.18h2.53V10h-2.53v3.96zM22.3 15.41a2.49 2.49 0 0 0 .54-.6 2.88 2.88 0 0 0 .35-.81 3.44 3.44 0 0 0 .13-1 3.58 3.58 0 0 0-.2-1.26 2.4 2.4 0 0 0-.63-1 2.85 2.85 0 0 0-1.07-.61 4.8 4.8 0 0 0-1.54-.13H16v10.22h2.53V16.3h.9l2.28 3.92h2.73l-2.84-4.37a3.33 3.33 0 0 0 .7-.44m-3.06-.92h-.74v-2.68h1a1.49 1.49 0 0 1 1 .32 1.22 1.22 0 0 1 .35 1 1.32 1.32 0 0 1-1.59 1.39"></path><path d="M24.62 6H5.38a3 3 0 0 0-2.82 3.24v11.52A3.05 3.05 0 0 0 5.38 24h19.24a3.05 3.05 0 0 0 2.82-3.24V9.24A3 3 0 0 0 24.62 6m1.33 14.76a1.6 1.6 0 0 1-1.33 1.75H5.38a1.6 1.6 0 0 1-1.32-1.75V9.24a1.6 1.6 0 0 1 1.32-1.75h19.24a1.6 1.6 0 0 1 1.33 1.75v11.52z"  ></path></svg>                </div>
                <div class="app-link-label">
                  <span>Human Resources</span>
                </div>
              </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="people")'  @click="onNavLink('/admin/people')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="people" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>applicationIcons</title><path d="M19.8 10.25a1.75 1.75 0 0 1 .1 3.5 1.84 1.84 0 0 1-1.8-1.7 1.65 1.65 0 0 1 1.7-1.8m0-1a2.75 2.75 0 1 0 2.7 2.8 2.78 2.78 0 0 0-2.7-2.8zM12.4 8.15a3 3 0 0 1 2.9 3 2.9 2.9 0 1 1-5.8.3v-.3a3 3 0 0 1 2.9-3m0-1a3.93 3.93 0 0 0-3.9 4 3.85 3.85 0 0 0 3.7 4.1 3.91 3.91 0 0 0 4.1-3.7v-.4a3.93 3.93 0 0 0-3.9-4zM25.8 19.35a3 3 0 0 0-1-2 7.09 7.09 0 0 0-5-1.7 8.42 8.42 0 0 0-2.7.4 9.44 9.44 0 0 0-.9.3 8.22 8.22 0 0 0-3.8-.6 11.93 11.93 0 0 0-3.7.6 6.91 6.91 0 0 0-4 3.1 3.87 3.87 0 0 0-.5 2.4.92.92 0 0 0 .9 1h14.4c1 0 1.2-1 1-2H25c.8 0 .9-.85.8-1.5zM19.6 21a1.39 1.39 0 0 1 0 .9H5.2v-.1a2.78 2.78 0 0 1 .3-1.8A6.34 6.34 0 0 1 9 17.25a10.24 10.24 0 0 1 3.5-.5 12.41 12.41 0 0 1 2.7.3 4.87 4.87 0 0 1 1.1.4 6.36 6.36 0 0 1 2.2 1.4 3.92 3.92 0 0 1 .8 1c.1.3.2.7.3 1.1zm5.2-1.1h-4.5a4.52 4.52 0 0 0-1.1-1.7 6.57 6.57 0 0 0-1.7-1.2 9.69 9.69 0 0 1 2.3-.3 6.13 6.13 0 0 1 4.3 1.5 2.22 2.22 0 0 1 .8 1.3.76.76 0 0 0-.1.35z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Company Directory</span>
                    </div>
                </div>


              <div class="app-link dot-right-center" v-if="$store.state.company == 'legacy'" data-show-dot="true" :data-selected='(activeAppLink=="access")'  @click="onNavLink('/admin/access')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="user-access" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M14.19 15.74a5.64 5.64 0 0 1-2.55-8A5.57 5.57 0 0 1 13.29 6a4.6 4.6 0 0 0-3.41 7.64l-2.07 7.7.78 1.06 2.15-8a4.68 4.68 0 0 0 .93.49l-2.3 8.57.39.54 3-1.32 1.64-6.12z" ></path><path d="M21.11 9.42A4.62 4.62 0 1 0 15.17 15l2.06 7.69 1.2.52-2.15-8a4.55 4.55 0 0 0 1.05 0l2.3 8.57.61.22 1.95-2.65-2.06-7.69a4.62 4.62 0 0 0 .98-4.24zM14.62 9a1.54 1.54 0 1 1 1.88 1.09A1.54 1.54 0 0 1 14.62 9z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>User Access</span>
                    </div>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="hiring")'  @click="onNavLink('/admin/hiring-home')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="hiring" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path   d="M12 14.25h4.5v1H12zM12 8.25h10.5v4.5H12zM18 14.25h4.5v1H18zM12 16.25h4.5v1H12zM18 16.25h4.5v1H18zM12 18.25h4.5v1H12zM18 18.25h4.5v1H18zM12 20.25h4.5v1H12zM18 20.25h4.5v1H18z"></path><path d="M9.75 6v3h-3a1.51 1.51 0 0 0-1.5 1.5v10.84A2.65 2.65 0 0 0 7.88 24h14.24a2.65 2.65 0 0 0 2.63-2.66V6h-15zM6 21.34V10.5a.75.75 0 1 1 1.5 0v10.13a.38.38 0 0 0 .75 0V9.75h1.5v11.59a1.87 1.87 0 1 1-3.75 0zm4.5-14.59H24v14.59a1.9 1.9 0 0 1-1.88 1.91H9.69a2.66 2.66 0 0 0 .81-1.91"  ></path></svg>                </div>
                <div class="app-link-label">
                  <span>Hiring</span>
                </div>
              </div>
              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="company")'  @click="onNavLink('/admin/company')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="company" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M24.09 11.43h-.8v-1.15a.44.44 0 0 0-.44-.43H21.3V7.92a.64.64 0 0 0-1.28 0v1.93h-.7v2.44h4.08v.92h-4.09v1.19h4.09v.92h-4.09v1.18h4.09v.92h-4.09v1.18h4.09v.92h-4.09v1.18h4.09v.93h-4.09V24h5.22V11.87a.44.44 0 0 0-.44-.44zM17.2 6.52h-.32v-.09a.44.44 0 0 0-.44-.43H6.67a.44.44 0 0 0-.44.43v.09h-.32a.44.44 0 0 0-.44.48v17h12.17V7a.44.44 0 0 0-.44-.48zm-5.91 14.2H6.64v-2h4.64v2zm0-3.18H6.64v-2h4.64v2zm0-3.18H6.64v-2h4.64v2zm0-3.18H6.64v-2h4.64v2zm5.18 9.55h-4.65v-2h4.64v2zm0-3.18h-4.65v-2h4.64v2zm0-3.18h-4.65v-2h4.64v2zm0-3.18h-4.65v-2h4.64v2z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Company Details</span>
                    </div>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="time")' @click="onNavLink('/admin/time-attendance-home')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="time-and-attendance" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M15 6a9 9 0 1 0 9 9 9 9 0 0 0-9-9zm0 16.54A7.54 7.54 0 1 1 22.54 15 7.55 7.55 0 0 1 15 22.54z"  ></path><path d="M16 15.32a1 1 0 0 0 0-.71 1 1 0 0 0-.56-.55V9.9h-.83v4.17a1 1 0 1 0 1.12 1.64l4.55 3.05.25-.37z"  ></path></svg>                </div>
                <div class="app-link-label">
                  <span>Time & Attendance</span>
                </div>
              </div>

              <div class="app-link dot-right-center" v-if="$store.state.company == 'enterprise'" data-show-dot="true" :data-selected='(activeAppLink=="documents")' @click="onNavLink('/admin/documents')">
                <div class="app-link-icon">
                  <svg class="aoLayer_1" data-name="Layer 1" viewBox="0 0 30 30" id="documents_cache5" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>documents</title><path d="M21.33 21.66a.57.57 0 0 1-.5.62h-9.59a.58.58 0 0 1-.53-.61V10.59a.58.58 0 0 1 .5-.63h7.56v1.94a.53.53 0 0 0 .46.5h2.1zm-12-1.74H9a.57.57 0 0 1-.54-.6V8.4A.57.57 0 0 1 9 7.78h9.7a.58.58 0 0 1 .54.62v.41H10.1a.54.54 0 0 0-.53.51v10.6zM20.25 9.76V7.25a.53.53 0 0 0-.53-.51H7.77a.49.49 0 0 0-.22.18.44.44 0 0 0-.09.31v13.2a.54.54 0 0 0 .54.5h1.6v1.86a.53.53 0 0 0 .53.5H22a.53.53 0 0 0 .53-.5V11.7z" ></path><path class="aoFill-8"   d="M12.02 14.85h6v-1h-6v1z"></path><path class="aoFill-10"   d="M19.25 16.85h-7.23v1h8v-1h-.77z"></path><path class="aoFill-11"   d="M12.02 18.85v1h8v-1h-8z"></path></svg>                </div>
                <div class="app-link-label">
                  <span>Documents</span>
                </div>
              </div>

                <hr class="app-group-header" />



              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="expense")'  @click="openTab('/#/expense-wire/dashboard')">
                <div class="app-link-icon expense-management">
                  <svg kui-icon="g-app-glyph-expense-management" viewBox="0 0 20 20" aria-hidden="true"   height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"  data-payxautoid="paychex.app.landing.shared.application-icon.EXPMGTEMPR">
                    <symbol id="g-app-glyph-expense-management" viewBox="0 0 20 20"><path d="M16.5 1H2c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h13c.55 0 1-.45 1-1v-4h2c.55 0 1-.45 1-1V3.5A2.5 2.5 0 0 0 16.5 1ZM14 17H3V3h11v14Zm3-5h-1V3.41c.05-.23.25-.41.5-.41h.09c.23.05.41.25.41.5V12Z"></path><path d="M13 13.5H4v2h9v-2ZM5.88 12h1.25v-1.25h.42c.82-.06 1.46-.73 1.46-1.56 0-.83-.7-1.56-1.56-1.56H5.52a.32.32 0 0 1-.26-.31v-.06A.32.32 0 0 1 5.57 7h2.81V5.75H7.13V4.5H5.88v1.25l-.62.03c-.71.14-1.25.78-1.25 1.53 0 .86.7 1.56 1.56 1.56H7.5c.15.03.26.16.26.31v.06a.32.32 0 0 1-.31.26H4.01v1.25h1.88V12h-.01ZM13 10h-3v2h3v-2Zm0-2.75h-3v2h3v-2Zm0-2.75h-3v2h3v-2Z"></path></symbol>
                    <use href="#g-app-glyph-expense-management"></use>
                  </svg>
                </div>
                <div class="app-link-label">
                  <span>Expense Management</span>
                </div>
              </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="ledger")'  @click="onNavLink('/admin/ledger')">
                <div class="app-link-icon">
                  <svg viewBox="0 0 30 30" id="general-ledger" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M24.62 6H5.38a3 3 0 0 0-2.82 3.24v11.52A3 3 0 0 0 5.38 24h19.24a3 3 0 0 0 2.82-3.24V9.24A3 3 0 0 0 24.62 6m1.32 14.76a1.6 1.6 0 0 1-1.33 1.75H5.38a1.6 1.6 0 0 1-1.32-1.75V9.24a1.6 1.6 0 0 1 1.32-1.75h19.24a1.6 1.6 0 0 1 1.33 1.75v11.52z" ></path><path d="M13.27 20.2a9.82 9.82 0 0 1-2.19.21 5 5 0 0 1-2-.38A3.87 3.87 0 0 1 7.58 19a4.67 4.67 0 0 1-.9-1.67 7.24 7.24 0 0 1-.31-2.19 6.6 6.6 0 0 1 .35-2.18 5 5 0 0 1 1-1.75A4.71 4.71 0 0 1 9.4 10a5.41 5.41 0 0 1 2.19-.42 7.41 7.41 0 0 1 2.94.53v2.09a5.19 5.19 0 0 0-1.13-.43 5.28 5.28 0 0 0-1.32-.16 2.84 2.84 0 0 0-2.29.93A3.88 3.88 0 0 0 9 15.11a3.7 3.7 0 0 0 .74 2.45 2.45 2.45 0 0 0 2 .88 4.62 4.62 0 0 0 .54 0 2.21 2.21 0 0 0 .51-.14v-1.8H11v-1.91h4v5a7 7 0 0 1-1.71.63M23.12 20.26h-6.34V9.77h2.6v8.46h3.74v2.03z" ></path></svg>
                </div>
                <div class="app-link-label">
                  <span>General Ledger</span>
                </div>
              </div>


              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="retirement")'  @click="onNavLink('/admin/retirement-home')">
                  <div class="app-link-icon">
                    <svg viewBox="0 0 30 30" id="retirement-services_cache2" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>retirement-services</title><path d="M27.71 6.55c0-.08-.13-.16-.23-.13l-.08.06a1.68 1.68 0 0 0-.21.41 1.73 1.73 0 0 1-.26.38 1.36 1.36 0 0 1-.44.34l-.35.12a3.15 3.15 0 0 0-.38-1.91A2.1 2.1 0 0 0 24 4.89a2 2 0 0 0-1.13.35 2 2 0 0 0-.7 2.33 2.05 2.05 0 0 0 1 1.06c.67-.64.93-1 .71-1.35s-.27-.51-.05-.67.49 0 .64.25c.51.74-.93 2.08-1.31 2.52a13.11 13.11 0 0 0-1.16-1 10.74 10.74 0 0 0-6.14-2.26 6.18 6.18 0 0 0-.66 0 11.55 11.55 0 0 0-4.75 1 1.56 1.56 0 0 0-1-.84A3.87 3.87 0 0 0 7.9 6c-.56 0-1.36.24-1.94.31s-.61.53-.27.94l1.57 2c-2.11 2-2.07 3.69-2.92 4.15a3.6 3.6 0 0 1-1.3.38c-.84.09-1.12.41-1 1.21s.18 1.52.3 2.28a1.46 1.46 0 0 0 1.51 1.35c1.35.13 1.18.2 2.42 1.37a10.25 10.25 0 0 0 1.43 1.36v2.31c0 1.05.41 1.43 1.19 1.45h1.73a1.25 1.25 0 0 0 1.21-1l.11-.5a10.62 10.62 0 0 0 3.46.66h.23a11 11 0 0 0 3.42-.66l.12.55a1.18 1.18 0 0 0 1.17.93h1.82c.73 0 1.15-.6 1.15-1.4 0-.57-.1-2-.16-2.82a8.36 8.36 0 0 0 2.15-5.81 8.08 8.08 0 0 0-.53-2.62 9.75 9.75 0 0 0-.67-1.64l1.16-1.3a1.07 1.07 0 0 1 .55-.37c.65-.06 1.41.08 1.86-.53a1.91 1.91 0 0 0 .04-2.05zm-6.38 14.31c.07.84.11 1.57.13 2.05a.31.31 0 0 1-.29.33h-.35a.32.32 0 0 1-.32-.25l-.31-1.36a.29.29 0 0 0-.35-.23l-1.49.5a8.47 8.47 0 0 1-5.82 0l-1.24-.47a.45.45 0 0 0-.57.28v.05l-.25 1.17a.35.35 0 0 1-.35.28h-.3a.34.34 0 0 1-.34-.34v-2.2a.63.63 0 0 0-.24-.5l-.38-.29c-.84-.65-1.49-1.5-2.31-2.16a3.14 3.14 0 0 0-.93-.57c-.27-.1-1-.08-1.23-.24l-.19-.2c-.05-.32-.09-.64-.13-1a.46.46 0 0 1 .31-.48 4.54 4.54 0 0 0 1-.41A3.67 3.67 0 0 0 6.89 13a7 7 0 0 1 1.63-2.37c3.58-3.37 11.18-3.8 13.94 1a7.89 7.89 0 0 1 1 4.4 6.66 6.66 0 0 1-1.68 3.66l-.31.35a.5.5 0 0 0-.13.36z" ></path><path d="M15.52 14.13c-.33-.11-.93-.3-.93-.73s.39-.53.84-.53a2 2 0 0 1 1.19.46l.66-1.33a3.83 3.83 0 0 0-1.68-.56v-1.16h-.84v1.12a2.15 2.15 0 0 0-2 2.25 1.86 1.86 0 0 0 1.48 1.84c.73.27 1.5.38 1.5.93s-.49.69-.88.69a2.77 2.77 0 0 1-1.68-.79l-.77 1.42a3.37 3.37 0 0 0 1.11.62 3.37 3.37 0 0 0 1.21.24v1.12h.84V18.5a2.22 2.22 0 0 0 2-2.32c.01-1.3-.99-1.69-2.05-2.05z" ></path></svg>
                  </div>
                  <div class="app-link-label">
                    <span>Retirement Services</span>
                  </div>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="flock")'  @click="openTab('/#/flock/flock-home')"  >
                <div class="app-link-icon">
                  <svg viewBox="0 0 20 22" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M19 4v13a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4h18zm-2 2H3v10h14V6zm-6 1v3h3v2h-3.001L11 15H9l-.001-3H6v-2h3V7h2zm2.382-6a1 1 0 0 1 .894.553L15 3H1V2a1 1 0 0 1 1-1h11.382z" ></path></svg>
                </div>
                <div class="app-link-label">
                  <span>Health & Benefits</span>
                </div>
              </div>


              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="hb")'  @click="onNavLink('/admin/hb-overview')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="health-and-benefits" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M16.06 13.1a1.21 1.21 0 0 0 1-.94 1 1 0 0 0-.65-1 2.8 2.8 0 0 0-.9-.27v2.27h.2l.31-.06m6.38-5.65A26 26 0 0 0 15.15 6 29.46 29.46 0 0 0 7.6 7.45s-.87 8.45 2.56 13C12.52 23.52 14.92 24 15 24c.07 0 2.47-.48 4.84-3.59 3.43-4.51 2.56-13 2.56-13m-5.63 9a.86.86 0 0 1 .9.6 1.2 1.2 0 0 1-.79 1.16 4 4 0 0 0-1.33 1.05v1.18h-.8a3.42 3.42 0 0 1-.3-1 1.1 1.1 0 0 1 .3-.77V17c-1.46-.43-2.2-1-2.2-1.73 0-.9.74-1.54 2.2-1.93V11A2.33 2.33 0 0 0 13 12.78l-.27-1-.88.33v-.15a3 3 0 0 1 2.35-2.19 1.08 1.08 0 0 1-.09-.44 1 1 0 1 1 2.08 0 1.16 1.16 0 0 1-.12.52 2.73 2.73 0 0 1 2.13 2.24c0 1.1-.75 1.82-2.1 2l-.54.1v2a8.58 8.58 0 0 0 1.22.21m-3.28-1.14c0 .15.34.42 1.26.72v-1.6c-.81.26-1.26.57-1.26.89M15.55 18a10.1 10.1 0 0 1 .94-.58c-.23 0-.56-.08-.94-.17V18z" ></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Health & Benefits</span>
                    </div>
                </div>





                <hr class="app-group-header" />
                <div class="app-group-header">
                    <span>OTHER</span>
                </div>
              <div class="app-link dot-right-center" data-show-dot="true" :data-selected='(activeAppLink=="settings")'  @click="onNavLink('/admin/settings')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="globalSettings_cache0" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><title>applicationIcons</title><path d="M22.67 13.72a2 2 0 0 1-1.34-3.24l.9-.9a1.28 1.28 0 1 0-1.81-1.81l-.9.9a2 2 0 0 1-3.24-1.34V6.05a1.28 1.28 0 0 0-2.56 0v1.28a2 2 0 0 1-3.24 1.34l-.91-.9a1.28 1.28 0 0 0-1.8 1.81l.91.91a2.08 2.08 0 0 1 .37 2 1.76 1.76 0 0 1-1.59 1.21H6.05a1.28 1.28 0 0 0 0 2.56h1.28A2.08 2.08 0 0 1 9 17.46a1.76 1.76 0 0 1-.26 2l-1 1a1.28 1.28 0 0 0 1.81 1.81l.91-.91a2 2 0 0 1 3.24 1.34v1.28a1.28 1.28 0 0 0 2.56 0v-1.31a2 2 0 0 1 3.24-1.34l.9.9a1.28 1.28 0 0 0 1.81-1.81l-.91-.91a2 2 0 0 1 1.34-3.24h1.28a1.28 1.28 0 1 0 0-2.56zM15 18.84A3.83 3.83 0 1 1 18.83 15 3.84 3.84 0 0 1 15 18.84z"></path></svg>
                    </div>
                    <div class="app-link-label">
                        <span>Company Settings</span>
                    </div>
                </div>

              <div class="app-link dot-right-center" data-show-dot="true"   :data-selected='(activeAppLink=="help")' @click="onNavLink('/admin/help-center')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="help" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M24 15a9 9 0 0 0-18 0 9 9 0 0 0 18 0zm-7.88 4.9a.55.55 0 0 1-.56.55h-1.12a.55.55 0 0 1-.56-.55v-1.09a.55.55 0 0 1 .56-.55h1.13a.55.55 0 0 1 .56.55v1.09zm0-4v.73a.55.55 0 0 1-.56.55h-1.12a.55.55 0 0 1-.56-.55V15c0-.6.14-1.09.84-1.09h.84a.55.55 0 0 0 .56-.55v-1.08a.55.55 0 0 0-.56-.54h-1.12a.55.55 0 0 0-.56.54.54.54 0 0 1-.56.55h-1.13a.44.44 0 0 1-.52-.54 3.39 3.39 0 0 1 6.7.54 3.27 3.27 0 0 1-2.25 3.07z"></path></svg>
                    </div>
                    <div class="app-link-label ">
                        <span>Help Center</span>
                    </div>
                </div>

                <div class="app-link dot-right-center" data-show-dot="true"   @click="onNavLink('https://app.sixfifty.com/auth/login?return_to=%2Fapp')">
                    <div class="app-link-icon">
                        <svg viewBox="0 0 30 30" id="online-hr-library" xmlns="http://www.w3.org/2000/svg" fit="" height="100%" width="100%" preserveAspectRatio="xMidYMid meet" focusable="false"><path d="M12.824 11.654c0-.275.194-.387.433-.25l5.118 2.957c.236.138.236.362 0 .5l-5.118 2.956c-.238.139-.433.025-.433-.25v-5.913z"></path><path d="M5.148 6.151c7.417.052 8.651 1.771 8.896 1.944.194.138.929.778.929.778s.351-.325.938-.75c.453-.328 2.266-1.984 8.938-1.973v14.874c-2.73.023-5.166.357-7.438 1.017-1.221.354-1.938.899-2.39 1.356-.548-.514-1.498-1.149-3.294-1.615-1.861-.481-4.074-.736-6.58-.758V6.151M25.572 5h-.4C16.551 5 15.065 7.357 15 7.455 14.927 7.347 13.429 5 4.828 5h-.4C4.191 5 4 5.227 4 5.501v16.172c0 .276.191.502.428.502h.4c2.966 0 5.093.327 6.612.722C14.614 23.72 14.579 25 15.02 25c.45 0 .594-1.238 2.715-1.854 1.518-.44 3.891-.973 7.438-.973h.4c.236 0 .428-.225.428-.502V5.501C26 5.226 25.809 5 25.572 5z"></path></svg>

                    </div>
                    <div class="app-link-label ">
                        <span>Online HR Library</span>
                    </div>
                </div>
            </div>
        </div>

    </div>


</template>

<script>
    export default {
        name: "flex-admin-side-nav",
        props: {
            activeLink: {
                type: String,
                required: false,
                default: null
            },
        },
        data: function () {
            return {}
        },
        methods: {
            onNavLink: function(url){
                let isExternal =  url.startsWith("http");
              if(isExternal){
                window.open(url,"_blank");
              }else{
                this.$store.commit("clearPanels");
                this.$router.push(url);
              }

            },
          openTab: function(url){


              this.$screens.showExternalPage({
                target: {
                  dataset: {
                    tgt: url,
                    tgtQuery: true
                  }
                }
              })


          }
        },
        computed: {
            activeAppLink: function(){
              if(this.$route.params.screen){
                return this.$route.params.screen.split("-")[0];
              }else{
                return "dashboard";
              }
            }


        }
    }
</script>

<style scoped>




    .main-nav {
        font-size: 0.9em;
        position: absolute;
        width: calc((225/1580) * 100%);
        box-sizing: border-box;
        background-color: white;
        top: 0;
        height: 0;
        padding-bottom: calc((920/1580) * 100%);


        font-family: "Helvetica", "Arial", sans-serif;
        -webkit-font-smoothing: antialiased;

    }

    .nav-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .icon-container svg {
        position: relative;
        height:100%;
        width: 30px;

    }

    .icon-container svg.help-svg {
        width: 24px;

    }





    .header-bar {
        position: relative;
        width: 100%;
        height: calc((60/920) * 100%);
        background-color: #0369b1;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .header-bar .logo {
        position: relative;
        width: calc((180/225) * 100%);
        height: calc((20/60) * 100%);

    }



    .app-group-header {
        font-size: 0.9em;
        margin: 0.9em;
        color: #7c8d99;
        box-sizing: border-box;
    }

    hr.app-group-header {
        border: 0;
        height: 1px;
        background-color: #D8D8D8;
        margin: calc((10/225) * 100%) calc((20/225) * 100%);
    }

    .app-links {
        position: relative;
        height: calc(((920 - 107)/920) * 100%);

    }

    .app-link {
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-items: center;
        height: calc((40/(920 - 107)) * 100%);
        width: 100%;
        box-sizing: border-box;
        padding: calc((10/225) * 100%);
        padding-left: calc((14/225) * 100%);
        color: #7c8d99;
        cursor: pointer;
        fill: #7c8d99;


    }

    .app-link svg {

        cursor: pointer;
    }

    .app-link-icon {
        position: absolute;
        display: block;
        width: calc((26/225)*100%);
        height: calc((26/40)*100%);
        cursor: pointer;

    }

    .app-link-icon.expense-management {
      position: absolute;
      display: block;
      width: calc((20/225)*100%);
      height: calc((20/40)*100%);
      cursor: pointer;
      margin-left: calc((5/225)*100%);

    }


    .app-link-label {

        padding-left: calc((40/225) * 100%);
        cursor: pointer;

    }

    .app-link:hover {
        color: #0369b1;
        fill: #0369b1;
    }

    .app-link:hover .app-link-icon svg {

    }

    .app-link.link-disabled {
        cursor: default;
        pointer-events: none;
    }

    .app-link[data-selected="true"]{
        background-color: #f3f7fa;
        color: #0369b1;
        fill: #0369b1;
    }

    .app-link[data-selected="true"]:before {
        content: "";
        width: calc((5/225) * 100%);
        background-color: rgb(3, 105, 177);
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;

    }

    .hidden {
        display: none;
    }

</style>
